/**
 * نغمة نجاح هادية (3 نوتات صاعدة زي الجرس) لتأكيد الطلب — متولّدة بالـ Web Audio
 * من غير أي ملف صوت. لو المتصفح منع الصوت بتتجاهل بهدوء.
 */
const NOTES = [
  { freq: 659.25, at: 0 }, // E5
  { freq: 830.61, at: 0.12 }, // G#5
  { freq: 987.77, at: 0.24 }, // B5
];

export const playSuccessChime = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const master = ctx.createGain();
    master.gain.value = 0.18;
    master.connect(ctx.destination);

    const start = ctx.currentTime + 0.05;
    NOTES.forEach(({ freq, at }, i) => {
      const t = start + at;
      const last = i === NOTES.length - 1;
      const duration = last ? 1.4 : 0.6;

      // نغمة أساسية + هارمونيك خفيف عشان تبقى زي الجرس
      [
        { type: 'sine', mult: 1, level: 1 },
        { type: 'sine', mult: 2, level: 0.18 },
      ].forEach(({ type, mult, level }) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = type;
        osc.frequency.value = freq * mult;
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.exponentialRampToValueAtTime(level, t + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
        osc.connect(gain).connect(master);
        osc.start(t);
        osc.stop(t + duration + 0.05);
      });
    });

    // نقفل الـ context بعد ما النغمة تخلص
    setTimeout(() => ctx.close().catch(() => {}), 2200);
  } catch {
    /* الصوت مش متاح — مش مشكلة */
  }
};
